module.exports = __webpack_public_path__ + "img/text-title.b0e07ac6.png";